var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pui-spinner',_vm._g(_vm._b({attrs:{"message":_vm.$attrs.message || _vm.$t('common.overrides.progress.loading')},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,slotIndex){return {key:slotIndex,fn:function(slotProps){return [_vm._t(slotIndex,null,null,slotProps)]}}})],null,true)},'pui-spinner',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }